import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { SettingsPage } from "./SettingsPage";

export const settings = typeCheckAppModule({
    NAME: "settings",
    Container: SettingsPage,
    route: Routes.settings,
});
